module.exports = __webpack_public_path__ + "static/media/ic-face-purple-original.eb63b138.svg";